<!--
 * @Description: 
 * @Date: 2020-07-14 14:29:19
 * @LastEditTime: 2021-03-05 16:19:47
--> 
<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb class="breadcrumb-container"></breadcrumb>

    <div class="app-menu" v-if="isShowTopChange">
      <el-select v-model="value" placeholder="请选择" @change="changeApp">
        <el-option
          v-for="item in topAppList"
          :key="item.id"
          :label="item.name"
          :value="item.pkg"
        >
        </el-option>
      </el-select>
    </div>
    <!-- <div class="app-menu" style="margin-left: 20px" v-if="isShowEvent">
      <el-select v-model="event" placeholder="请选择" @change="changeEvent">
        <el-option
          v-for="item in eventList"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div> -->

    <div class="right-menu">
      <!-- <div class="menu-list">
        <router-link to="/projectManager" v-if="hasAdmin">
          <div class="ml-item">
            <svg-icon icon-class="xiangmulieb" /> 项目列表
          </div>
        </router-link>
        <span v-if="hasAdmin">|</span>
        <router-link to="/">
          <div class="ml-item"><svg-icon icon-class="shouye" /> 首页</div>
        </router-link>
        <span>|</span>

        <div class="ml-item"><svg-icon icon-class="person" /> 管理员</div>
        <span>|</span>

        <div class="ml-item" @click="logout">
          <svg-icon icon-class="tuichu" /> 退出
        </div>
      </div> -->

      <!-- <div class="navbar-menu">
        <el-dropdown class="avatar-container" trigger="click">
          <div class="avatar-wrapper">
            <img src="https://joeschmoe.io/api/v1/random" class="user-avatar" />
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <router-link to="/">
              <el-dropdown-item>
                <span style="display: block">首页</span>
              </el-dropdown-item>
            </router-link>
            <el-dropdown-item divided @click.native="logout">
              <span style="display: block">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";

export default {
  components: { Breadcrumb, Hamburger },
  data() {
    return {
      hasAdmin: false,
      options: [],
      topAppList: [],
      // eventList: [
      //   {
      //     value: "front",
      //     name: "前台",
      //   },
      //   {
      //     value: "back",
      //     name: "后台",
      //   },
      //   {
      //     value: "live",
      //     name: "联网",
      //   },
      // ],
      value: "",
      event: "",
    };
  },
  watch: {
    cur_app(newVal) {
      this.value = newVal;
    },
    cur_event(newVal) {
      this.event = newVal
    },
    // 第一次进来避免没有 select选中值和 select列表
    $route(to) {
      if (to.path === "/set/app-detail") {
        this.value = localStorage.getItem("curPkg");
        this.topAppList = JSON.parse(localStorage.getItem("topAppList"));
        // console.log(this.topAppList, 'xxxx');
      }
    },
  },
  computed: {
    ...mapGetters(["sidebar", "cur_app", "cur_event"]),
    isShowTopChange() {
      console.log(this.$route.query);
      if (this.$route.name === "app-detail") {
        return true;
      } else {
        return false;
      }
    },
    isShowEvent() {
      if (+this.$route.query.type === 3) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logout() {
      this.$store.dispatch("user/logout");
      this.$router.push("/login");
    },
    changeApp(val) {
      this.$store.dispatch("app/setApp", val);
      localStorage.setItem("curPkg", val);
    },
    // changeEvent(val){
    //   console.log(val);
    //   this.$store.dispatch('app/setEvent', val)
    //   localStorage.setItem("curEvent", val);
    // }
  },
  created() {
    this.hasAdmin = localStorage.getItem("project_id") === "null";
    this.value = localStorage.getItem("curPkg");
    // this.event = localStorage.getItem("curEvent");
    this.topAppList = JSON.parse(localStorage.getItem("topAppList"));
  },
};
</script>

<style lang="scss">
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  box-shadow: 0 -5px 10px 0 #2d3a5b;
}
.breadcrumb-container {
  float: left;
}
.right-menu {
  float: right;
  height: 100%;
}
.menu-list {
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 30px;
  font-size: 14px;
  color: #606266;
  span {
    display: inline-block;
    margin-left: 20px;
    margin-right: 20px;
  }
}
.ml-item {
  cursor: pointer;
  .svg-icon {
    margin-right: 10px;
  }
}
.navbar-menu {
  // float: right;
}
.avatar-container {
  margin-right: 30rpx;
  .avatar-wrapper {
    margin-top: 5px;
    position: relative;
    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
}
.hamburger-container {
  float: left;
  height: 100%;
  display: flex;
  align-items: center;
}
.app-menu {
  float: left;
  // margin-left: 20px;
  width: 300px;
  height: 100%;
  line-height: 50px;
}
</style>